import React, { Dispatch } from "react";

export default function useLocalStorage<R extends string = string>(key: string, initialValue = ""): [R, Dispatch<string>] {
  const [ value, setValue ] = React.useState(() => (localStorage.getItem(key) || initialValue));

  React.useEffect(() => {
    localStorage.setItem(key, value as string);
  }, [ value, key ]);

  return [ (value as R), setValue ];
}
